@if (renewalPricesObjects$ | async; as renewalPricesObjects) {
  <div>
    @if (renewalPricesObjects.length > 0) {
      <h3 class="text-center" i18n>Prime du renouvellement</h3>
      @for (obj of renewalPricesObjects; track obj) {
        <div class="layout__inner-card w-full p-5">
          <p class="font-bold mb-3">{{ obj.duration }}</p>
          <div class="flex justify-content-between">
            <div class="self-end">
              <span class="self-end"
                ><strong>{{ obj.price | currency }}</strong></span
              >
              <span class="text-sm line-height-4" i18n>/mois</span>
            </div>
            <div class="self-end">
              <span class="self-end"
                ><strong>{{ obj.renewalPrices[0] | currency }}</strong></span
              >
              <span class="text-sm line-height-4" i18n>/mois</span>
            </div>
          </div>
          <div class="flex justify-content-between">
            <div class="justify-content-start" i18n>1ère année</div>
            <hr class="renewal-card__line" />
            <div class="self-end">{{ getRenewalYearText(obj.duration) }}</div>
          </div>
        </div>
      }
    } @else {
      <h3 class="text-center" i18n><i>Aucune prime de renouvellement</i></h3>
    }
  </div>
} @else {
  @for (l of [].constructor(7); track l) {
    <div class="w-full p-5">
      <p-skeleton height="150px"></p-skeleton>
    </div>
  }
}
